<template>
  <q-page>
    <div class="row">
      <div class="col-12">
        <q-card>
          <q-card-section>
            <div class="row items-center">
              <div style="display: inline-block" class="text-h6">
                Competitions
              </div>
              <q-btn
                class="q-ml-md"
                color="secondaryButton"
                text-color="accent"
                no-caps
                unelevated
                icon="mdi-filter-outline"
                :loading="dataLoading"
              >
                <q-badge floating>{{ filtersActive }}</q-badge>
                <q-menu>
                  <div class="row q-pa-md">
                    <div class="col-12">
                      <div class="text-h6 q-mb-none">Filters</div>
                    </div>
                    <div class="col-12 q-mb-sm">
                      <q-btn-group flat push class="full-width">
                        <q-btn
                          style="width: 50%"
                          :color="
                            filter.view == 'Live' ? 'accent' : 'secondary'
                          "
                          :text-color="
                            filter.view == 'Live' ? 'secondary' : 'accent'
                          "
                          push
                          label="Live"
                          @click="filter.view = 'Live'"
                        />
                        <q-btn
                          style="width: 50%"
                          :color="
                            filter.view == 'Archived' ? 'accent' : 'secondary'
                          "
                          :text-color="
                            filter.view == 'Archived' ? 'secondary' : 'accent'
                          "
                          push
                          label="Archived"
                          @click="filter.view = 'Archived'"
                        />
                      </q-btn-group>
                    </div>
                    <div class="col-12 q-mb-sm">
                      <q-select
                        :options="seasons"
                        v-model="filter.season"
                        label="Season"
                        v-bind="siteCFG.fields.general"
                        clearable
                      >
                      </q-select>
                    </div>
                  </div>
                </q-menu>
              </q-btn>
              <q-space />
              <q-btn
                class="q-mr-md"
                color="positive"
                no-caps
                unelevated
                :text-color="
                  filter.status == 'entriesOpen' ? 'positive' : 'white'
                "
                :flat="filter.status == 'entriesOpen'"
                @click="toggleStatusFilter('entriesOpen')"
              >
                <span>
                  {{ statCount.entriesOpen }}
                </span>
                <q-tooltip>Entries Open</q-tooltip>
              </q-btn>
              <q-btn
                class="q-mr-md"
                color="orange"
                :text-color="filter.status == 'active' ? 'orange' : 'white'"
                :flat="filter.status == 'active'"
                no-caps
                unelevated
                @click="toggleStatusFilter('active')"
              >
                <span>
                  {{ statCount.active }}
                </span>
                <q-tooltip>Active</q-tooltip>
              </q-btn>
              <q-btn
                class="q-mr-md"
                color="blue-grey"
                :text-color="
                  filter.status == 'finishedOrClosed' ? 'blue-grey' : 'white'
                "
                :flat="filter.status == 'finishedOrClosed'"
                no-caps
                unelevated
                @click="toggleStatusFilter('finishedOrClosed')"
              >
                <span>
                  {{ statCount.finishedOrClosed }}
                </span>
                <q-tooltip>Entries Closed/Event Finished</q-tooltip>
              </q-btn>
              <q-input
                style="max-width: 70%"
                filled
                v-model="filter.search"
                debounce="200"
                label="Search"
                clearable
                dense
              >
                <template #prepend>
                  <q-icon name="mdi-magnify"> </q-icon>
                </template>
              </q-input>
            </div>
          </q-card-section>

          <q-separator />
          <q-card-section class="q-pa-none">
            <div v-if="gridData">
              <div class="row">
                <!-- <div class="col-12 my-0 py-0 pl-6">
                  *Double click row to open
                </div> -->

                <div class="col-12 mt-0 pt-0">
                  <datatable
                    v-if="$q.screen.gt.sm"
                    :filter="filter"
                    :externalFilter="externalFilter"
                    :flat="true"
                    :data="gridData"
                    :columns="columns"
                    @rowDoubleClick="handleDoubleClick"
                  >
                    <template
                      slot="body-cell-competition_name"
                      slot-scope="data"
                    >
                      <q-td
                        :class="{
                          currentlyDeployedTD: data.props.value == 1,
                          notDeployedTD: data.props.value != 1
                        }"
                        :props="data.props"
                      >
                        {{ data.props.row.competition_name }}

                        <q-chip
                          class="text-white float-right"
                          :color="competitionStatus(data.props.row).color"
                          >{{ competitionStatus(data.props.row).label }}</q-chip
                        >
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td
                        :class="{
                          currentlyDeployedTD: data.props.value == 1,
                          notDeployedTD: data.props.value != 1
                        }"
                        :props="data.props"
                      >
                        <q-btn
                          @click="handleDoubleClick(data.props.row)"
                          round
                          flat
                          color="black"
                        >
                          <q-icon name="mdi-open-in-new"></q-icon>
                          <q-tooltip>Open Competition</q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </datatable>
                  <!-- Mobile View -->
                  <q-scroll-area
                    style="height: calc(100vh - 260px) !important"
                    v-if="$q.screen.lt.md"
                  >
                    <div class="row">
                      <div
                        class="col-12 q-pa-sm"
                        v-for="(competition, index) in gridData"
                        :key="`competition_${index}`"
                      >
                        <q-card>
                          <q-card-section
                            class="bg-primary text-white text-bold"
                            style="font-size: 16px"
                          >
                            {{ competition.competition_name }}
                          </q-card-section>
                          <q-separator></q-separator>
                          <q-card-section>
                            <div class="row">
                              <div class="col-6">
                                <b>Start Date</b>
                                <br />
                                {{
                                  competition.start_date | momentFormatDMYRaw
                                }}
                              </div>
                              <div class="col-6">
                                <b>Entries Close Date</b>
                                <br />
                                {{
                                  competition.entriesCloseDate
                                    | momentFormatDMYRaw
                                }}
                              </div>
                            </div>
                          </q-card-section>
                          <q-separator></q-separator>
                          <q-card-section class="q-py-xs">
                            <div class="row">
                              <div class="col"></div>
                              <q-btn
                                flat
                                no-caps
                                label="Open"
                                dense
                                class="float-right"
                                @click="handleDoubleClick(competition)"
                              ></q-btn>
                            </div>
                          </q-card-section>
                        </q-card>
                      </div>
                    </div>
                  </q-scroll-area>
                </div>
              </div>
            </div>
          </q-card-section>
          <!-- <expandedToolbar
            :newButton="true"
            @newButtonClick="newDialog = true"
          /> -->
        </q-card>
      </div>
    </div>
    <q-dialog
      v-model="viewDetailsDialog"
      persistent
      :max-width="$q.screen.gt.sm ? '90vw' : '100vw'"
      :maximized="$q.screen.lt.md"
    >
      <q-card
        v-if="viewDetailsDialog"
        tile
        :style="
          `width: ${$q.screen.gt.sm ? '90vw' : '100vw'}; max-width: ${
            $q.screen.gt.sm ? '90vw' : '100vw'
          }`
        "
      >
        <q-card-section class="q-pa-sm q-pl-md">
          <div class="row items-center" style="position: relative">
            <div style="display: inline-block" class="text-h6">
              Competition -
              {{
                currentCompetition ? currentCompetition.competition_name : ""
              }}
            </div>
            <q-space />
            <q-btn
              style="position: absolute; right: 0px"
              round
              flat
              icon="mdi-close"
              @click="close"
            ></q-btn>
          </div>
        </q-card-section>
        <q-separator />
        <q-card-section class="formHeight q-pa-none">
          <q-scroll-area style="height: calc(100vh - 191px) !important">
            <entriesForm
              ref="editForm"
              :id="viewFormData.id"
              @close="close"
              @loadingStateChanged="state => (saveLoading = state)"
            />
          </q-scroll-area>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { mapGetters } from "vuex";
import datatable from "@/components/datatable/datatable.vue";
import entriesForm from "@/components/competitions/entriesForm.vue";
import moment from "moment";

// import { Notify } from "quasar";

export default {
  components: {
    datatable,
    entriesForm
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      gridData: "competitions/list",
      dataLoading: "competitions/listLoading",
      currentCompetition: "competitions/current",
      siteCFG: "settings/siteCFG",
      seasons: "settings/availableSeasons"
    }),
    filtersActive: function() {
      let count = 0;

      if (this.filter.season) {
        count += 1;
      }

      return count;
    },
    statCount: function() {
      let counts = {
        entriesOpen: 0,
        active: 0,
        finishedOrClosed: 0
      };

      this.gridData.forEach(competition => {
        let entriesCloseDate = this.$moment(competition.entriesCloseDate);
        let start_date = this.$moment(competition.start_date);
        let competitionFinishDate = this.$moment(competition.end_date);
        let now = this.$moment();

        if (now < entriesCloseDate) {
          counts.entriesOpen += 1;
        } else if (now < start_date) {
          counts.finishedOrClosed += 1;
        } else if (now < competitionFinishDate) {
          counts.active += 1;
        } else if (now < entriesCloseDate) {
          counts.finishedOrClosed += 1;
        } else {
          counts.finishedOrClosed += 1;
        }
      });

      return counts;
    }
  },
  data: () => ({
    // data-table
    columns: [
      {
        name: "competition_name",
        label: "Competition",
        align: "left",
        field: "competition_name",
        style:
          "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",

        sortable: true
      },
      {
        name: "start_date",
        label: "Start Date",
        align: "left",
        field: "start_date",
        format: val => (val != null ? moment(val).format("DD-MMM, YYYY") : ""),
        sortable: true
      },
      {
        name: "entriesCloseDate",
        label: "Entries Close Date",
        align: "left",
        field: "entriesCloseDate",
        format: val => (val != null ? moment(val).format("DD-MMM, YYYY") : ""),
        sortable: true
      },
      {
        name: "actions",
        label: "Actions",
        align: "left",
        sortable: false
      }
    ],

    createLoading: false,

    newDialog: false,

    // View and Edit
    viewFormData: {},
    saveLoading: false,
    viewDetailsDialog: false,

    // Filter
    filter: {
      search: "",
      view: "Live",
      status: null,
      season: `${
        new Date().getMonth() >= 6 ? moment().year() : moment().year() - 1
      }-${new Date().getMonth() >= 6 ? moment().year() + 1 : moment().year()}`
    }
  }),
  watch: {
    $route: function() {
      this.handleRoute();
    }
  },
  mounted() {
    this.loadData();
    this.handleRoute();
  },
  methods: {
    handleDoubleClick(row) {
      this.$router.push(`${this.$route.path}/${row.id}`);
    },
    loadData() {
      this.$store.dispatch("competitions/loadAll");
    },
    handleRoute() {
      if (this.$route.params.id) {
        this.viewFormData = { id: this.$route.params.id };
        this.$nextTick(() => {
          this.viewDetailsDialog = true;
        });
      } else {
        this.viewDetailsDialog = false;
      }
    },
    close() {
      this.$router.push("/entries/competitions");
    },
    externalFilter(rows, terms, cols) {
      return rows.filter(row => {
        let passed = 0;

        // Text Search
        if (this.filter.search != "" && this.filter.search) {
          for (let i = 0; i < cols.length; i++) {
            let val = `${row[cols[i].field]}`.toLowerCase();
            passed +=
              val.toLowerCase().indexOf(this.filter.search.toLowerCase()) > -1
                ? 1
                : 0;

            if (passed == 1) {
              i = cols.length;
            }
          }
        } else {
          passed += 1;
        }

        // Archived Filter
        if (
          (this.filter.view == "Live" && !row.archived_at) ||
          (this.filter.view == "Archived" && row.archived_at)
        ) {
          passed += 1;
        }

        // Season Filter
        if (this.filter.season) {
          let seasonStart = moment(
            `${this.filter.season.split("-")[0]}-07-01`
          ).startOf("day");
          let seasonEnd = moment(
            `${this.filter.season.split("-")[1]}-06-30`
          ).endOf("day");
          // console.log(row.end_date, seasonStart, seasonEnd);
          if (
            (moment(row.end_date) > seasonStart &&
              moment(row.end_date) < seasonEnd) ||
            row.status == "DRAFT" ||
            row.end_date == null
          ) {
            passed += 1;
          }
        } else {
          passed += 1;
        }

        // Status Filter
        if (this.filter.status) {
          if (
            this.filter.status == "entriesOpen" &&
            moment(row.entriesCloseDate) > moment()
          ) {
            passed += 1;
          } else if (
            this.filter.status == "active" &&
            moment(row.start_date) < moment() &&
            moment(row.end_date) > moment()
          ) {
            passed += 1;
          } else if (
            this.filter.status == "finishedOrClosed" &&
            moment(row.end_date) < moment()
          ) {
            passed += 1;
          }
        } else {
          passed += 1;
        }

        if (passed == 4) {
          return true;
        } else {
          return false;
        }
      });
    },
    competitionStatus(data) {
      let entriesCloseDate = this.$moment(data.entriesCloseDate);
      let start_date = this.$moment(data.start_date);
      let competitionFinishDate = this.$moment(data.end_date);
      let now = this.$moment();

      if (now < entriesCloseDate) {
        return {
          color: "positive",
          label: "Entries Open"
        };
      }

      if (now < start_date) {
        return {
          color: "blue-grey",
          label: "Entries Closed"
        };
      }
      if (now < competitionFinishDate) {
        return {
          color: "orange",
          label: "Active"
        };
      }
      if (now < entriesCloseDate) {
        return {
          color: "blue-grey",
          label: "Finished"
        };
      }

      return {
        color: "blue-grey",
        label: "Finished"
      };
    },
    toggleStatusFilter(status) {
      this.filter.status = this.filter.status == status ? null : status;
    }
  }
};
</script>

<style lang="scss" scoped>
#depthCard:hover {
  background: #5cb3ff;
  color: white;
}

.formHeight {
  min-height: calc(100vh - 175px);
  max-height: 1000px;
}
</style>
